'use strict';

module.exports = require('./core/');


//////////////////
// WEBPACK FOOTER
// /Users/annademyanchuk/Downloads/suedmetall/node_modules/modal-video/lib/index.js
// module id = 13
// module chunks = 0